@if (showGrid) {
  <app-standard-page-content-grid>
    <div class="horizontal-wrap justify-content-start">
      <div class="me-2 mb-1">
        <app-grid-expand-collapse-button
          #expandCollapseButton
          key="asset-transactions"
        ></app-grid-expand-collapse-button>
      </div>
      <div class="btn-group me-2 mb-1">
        <input
          id="includeReversals-input"
          type="radio"
          class="btn-check"
          [value]="true"
          [(ngModel)]="includeReversals"
          [disabled]="!hasReversals"
        />
        <label
          id="includeReversals"
          for="includeReversals-input"
          class="btn btn-outline btn-sm mb-0"
        >
          Show Reversals
        </label>
        <input
          id="excludeReversals-input"
          type="radio"
          class="btn-check"
          [value]="false"
          [(ngModel)]="includeReversals"
          [disabled]="!hasReversals"
        />
        <label
          id="excludeReversals"
          for="excludeReversals-input"
          class="btn btn-outline btn-sm mb-0"
        >
          Hide Reversals
        </label>
      </div>
    </div>
  </app-standard-page-content-grid>
  <app-standard-page-content-grid>
    <app-grid-table
      [expandCollapseButton]="expandCollapseButton"
      [rowData]="rowData"
      [rowHeight]="getRowHeight"
      [rowClassRules]="rowClassRules"
      [isRowGroupOpenByDefault]="isRowGroupOpenByDefault"
      [exportButton]="exportButton"
    >
      <app-grid-column
        field="openingBalanceLabel"
        [hide]="true"
        [rowGroup]="!hideGrouping"
      >
      </app-grid-column>
      <app-grid-column
        field="financialYear"
        [hide]="true"
        [rowGroup]="!hideGrouping"
      >
      </app-grid-column>
      <app-grid-column
        headerName="Date"
        field="date"
        fixed="left"
        cellClass="text-nowrap"
        [maxWidth]="220"
      >
        <ng-template let-value let-data="data">
          @if (data.warnings?.length) {
            <button
              type="button"
              class="row-warning btn btn-warning rounded-0"
              [ngbPopover]="RowWarnings"
              [popoverContext]="{ $implicit: data.warnings }"
              placement="end"
              container="body"
            >
              <i-lucide name="alert-triangle"></i-lucide>
            </button>
          }
          {{ value | aadate }}
        </ng-template>
      </app-grid-column>
      <app-grid-column
        headerName="Type"
        field="type"
        [getValue]="getTransactionTypeValue"
      ></app-grid-column>
      <app-grid-column-group headerName="Asset" [defaultOpen]="true">
        <app-grid-column
          headerName="Cost"
          field="cost"
          aggFunc="sum"
          columnGroupShow="open"
          cellClass="text-end"
          valueFormat="currency"
        ></app-grid-column>
        <app-grid-column
          headerName="Depreciation"
          field="depreciation"
          aggFunc="sum"
          columnGroupShow="open"
          cellClass="text-end"
          valueFormat="currency"
        ></app-grid-column>
        @if (showTaxableDepreciation) {
          <app-grid-column
            headerName="Taxable Depreciation"
            headerAbbreviation="Taxable Depn"
            field="taxableDepreciation"
            aggFunc="sum"
            columnGroupShow="open"
            cellClass="text-end"
            valueFormat="currency"
          ></app-grid-column>
        }
        <app-grid-column
          [headerName]="wdvName"
          field="writtenDownValue"
          fixed="right"
          aggFunc="last"
          cellClass="text-end"
          valueFormat="currency"
        ></app-grid-column>
      </app-grid-column-group>
      <app-grid-column
        headerName="Description"
        field="descriptionAndSource"
        [getValue]="getTransactionDescriptionAndSource"
        [grow]="3"
      >
        <ng-template let-data="data">
          <app-transaction-description
            [data]="data"
            [assetGroups]="assetGroups"
          ></app-transaction-description>
        </ng-template>
      </app-grid-column>
      <app-grid-column
        headerName="Description"
        field="description"
        [getValue]="getTransactionDescription"
        [hide]="true"
      >
      </app-grid-column>
      <app-grid-column
        headerName="Source"
        field="source"
        [getValue]="getTransactionSource"
        [hide]="true"
      >
      </app-grid-column>
    </app-grid-table>
  </app-standard-page-content-grid>
  @if (areMoreTransactionsAvailable) {
    <app-standard-page-content-grid>
      <button
        type="button"
        class="btn btn-outline mb-3"
        [disabled]="transactionsLoading"
        (click)="onGetMoreTransactions()"
      >
        <i-lucide name="plus-circle"></i-lucide>
        Show More Transactions
      </button>
    </app-standard-page-content-grid>
  }
}

<ng-template #RowWarnings let-warnings>
  @for (warning of warnings; track warning; let lastWarning = $last) {
    @for (line of warning.text; track line; let lastLine = $last) {
      <p [class.mb-0]="lastWarning && lastLine">
        {{ line }}
      </p>
    }
    @switch (warning.action) {
      @case ('REASSESS') {
        <button
          type="button"
          authorizeEnable
          [authorizeRegister]="RegisterPermission.UpdateAsset"
          class="btn btn-primary mt-4"
          (click)="reassess.emit()"
        >
          Reassess <i-lucide name="chevron-right"></i-lucide>
        </button>
      }
    }
    @if (!lastWarning) {
      <hr />
    }
  }
</ng-template>
